import { render, staticRenderFns } from "./OrganisationsManager.vue?vue&type=template&id=4f09a8be&scoped=true"
import script from "./OrganisationsManager.vue?vue&type=script&lang=js"
export * from "./OrganisationsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f09a8be",
  null
  
)

export default component.exports